import { produce } from 'immer';

import { getWPPage } from '../actions/wpBlog';

const initialState = {
  pageData: {},
  loading: false,
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET POST
    case getWPPage.types.START:
      state.pageData = {};
      state.loading = true;
      return state;

    case getWPPage.types.SUCCESS:
      state.pageData = action.payload.data;
      state.loading = false;
      return state;

    case getWPPage.types.FAIL:
      state.loading = false;
      return state;

    default:
      return state;
  }
});

export default reducer;
